import _default from './Icon';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./node_modules/semantic-ui-react/dist/es/elements/Icon/index.js
// module id = 22
// module chunks = 0